import React, { useEffect, useState } from 'react'

const viewApplicantNavigation = (Props: any, setActive: any) => {


	// eslint-disable-next-line react-hooks/rules-of-hooks
	const [actives, setActives] = useState("/ApplicantInfo")

	const ApplicantNav = [
		{ title: "Applicant Info", path: "/ApplicantInfo" },
		{ title: "Audit History", path: "/AuditHistory" },
		{ title: "Notes", path: "/Notes" },
	]

	// eslint-disable-next-line react-hooks/rules-of-hooks
	useEffect(() => {
		Props.setActive(actives)
	}, [Props, actives, setActive])


	return (
		<div className='viewsidebarNavigation'>
			{ApplicantNav.map((item, i) => (
				<div key={i} className={actives === item?.path ? 'viewsidebarNavigationsub1' : 'viewsidebarNavigationsub'} onClick={() => setActives(item.path)}>{item.title}</div>
			))}
		</div>
	)
}

export default viewApplicantNavigation



